import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import CCrud from "components/Molecules/Crud";
import { initialValues, structure, validationSchema } from "./structure";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Box, Stack } from "@mui/material";
import Breadcrumb from "components/Atoms/SharedComponents/Breadcrumbs/Breadcrumb";
import AddIcon from "@mui/icons-material/Add";
import { detailsData } from "./details";
import { useEffect } from "react";

const BetweenZonesFeesTemplate = ({
  handlePageChange,
  data,
  details,
  count,
  handelSubmit,
  deleteFun,
  filterList,
  actionsList,
  breadcrumbs,
  setFilterObj,
  rowData,
  paginationPage,
  headerChildren,
  modalComponents,
  openDeleteModal,
  setOpenDeleteModal,
  handleDeleteRequest,
  formChildren,
  fulfillmentCenters,
  zones,
  can_create,
  options,
  handleCityChange,
  cityId,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [filteredZones, setFilteredZones] = useState([]);
  let [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const [supportedLang, setSupportedLang] = useState("en");

  return (
    <>
      <Box>
        <Stack
          direction="row"
          alignSelf="start"
          justifyContent="start"
          gap={2}
          width="100%"
          // mb={1}
        >
          <Breadcrumb data={breadcrumbs} />
        </Stack>
        <CCrud
          detailsTemplateData={{
            pageTitle: t("between_zones_fees.details"),
            data: {
              images: details?.image && [{ id: 0, img: details?.image }],
              list: detailsData(t, { data: details }),
            },
          }}
          table={{
            list: data,
            listTitle: t("between_zones_fees.title"),
            createBtnTitle: can_create && t("between_zones_fees.add"),
            CreateBtnIcon: AddIcon,
            createBtnFun: () => navigate("?type=form"),
            columns: [
              { accessor: "id", Header: "#" },
              {
                accessor: "origin_zone.name",
                Header: t("between_zones_fees.origin_zone"),
                sort: true,
              },
              {
                accessor: "destination_zone.name",
                Header: t("between_zones_fees.destination_zone"),
                sort: true,
              },
              { accessor: "city.name", Header: t("common.city") },
              { accessor: "delivery_fees", Header: t("between_zones_fees.delivery_fees") },
              { accessor: "Actions", Header: t("cart_logs.actions") },
            ],
            isSearch: true,
            searchInputPlaceholder: t("between_zones_fees.search_by_zone"),
            isChecked: false,
            total_count: count,
            isSort: true,
            setFilterObj,
            className: "organization-table system-configurations-table",
            paginationPage: paginationPage,
            handlePageChange,
            rowData: rowData,
            filterList,
            className: "main-table",
            actionsList, //if you want to add custom actions list
            headerChildren,

            details,
            openDeleteModal,
            setOpenDeleteModal,
            handleDeleteRequest,
          }}
          form={{
            initialValues: !id ? {} : initialValues(details, supportedLang),
            structure: () => structure(options, cityId, t),
            validationSchema: validationSchema(t),
            deleteFun: deleteFun,
            title: id ? t("between_zones_fees.edit") : t("between_zones_fees.add"),
            submitTitle: id ? t("admin_users.btn_update") : t("admin_users.btn_add"),
            onSubmit: handelSubmit,
            className: { form: "main-form", actionButton: "main-form-buttons" },
            formChildren,
          }}
          // DetailsComponent={<Details />} //to send details component diff from the default
          modalComponents={modalComponents}
        />
      </Box>
    </>
  );
};

export default BetweenZonesFeesTemplate;
